<script setup lang="ts">
import { inject, Ref, ref } from 'vue';
import { useViewComposable } from '@/views/composable';
import ApplyManageButton from '@/components/ApplyManageButton.vue';
import CityList from './CityList.vue';

const dialogRef = inject('dialogRef') as Ref;
const onApply = dialogRef?.value?.options?.emits?.onApply;
const handleReOpen = dialogRef?.value?.options?.emits?.handleReOpen;
const type = dialogRef?.value?.options.data.type;
const cityList = dialogRef?.value?.options.data.cityList;

const { formatDataExport, renderNameFileExport } = useViewComposable();

const refCityList = ref();

const handleCloseModal = () => {
  dialogRef.value.close();
  if (type === 'REVERT') {
    handleReOpen();
  }
};

const handleApplyImport = () => {
  dialogRef.value.close();
  onApply();
};

const handleApplyRevert = () => {
  dialogRef.value.close();
  onApply();
};
</script>
<template>
  <div>
    <div>
      <CityList isView :city="cityList" ref="refCityList" />
    </div>
    <div>
      <ApplyManageButton
        :type="type"
        @applyImport="handleApplyImport()"
        @handleClose="handleCloseModal()"
        :sheetColumnStyle="refCityList?.sheetColumnStyle"
        :dataExport="formatDataExport(refCityList?.handleDataExport(cityList), refCityList?.formatFieldColumnExport())"
        :fileName="renderNameFileExport('Gateway/Destination/Region_Reference')"
        @applyRevert="handleApplyRevert()"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.break-spaces {
  white-space: break-spaces;
}

.import-button,
.revert-button {
  background-color: #00af87;
}
</style>
